/** @flow */
import styled from 'styled-components';

export default styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  -webkit-flex: 1;
  background-color: ${({ theme }) => theme.colors.cardBackground};
  box-shadow: ${({ theme }) => theme.colors.boxShadow};
`;

export const CardV2 = styled.div`
  display: flex;
  -webkit-flex: 1;
  background-color: ${({ theme }) => theme.colors.cardBackground};
  box-shadow: ${({ theme }) => theme.colors.boxShadow};
`;



// WEBPACK FOOTER //
// ./src/common/components/Card.js